exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.admin-dashboard[data-v-0c013cc0] {\n  padding: 20px;\n}\n.clearfix-now[data-v-0c013cc0] {\n  background-color: #ddbd52;\n  font-size: large;\n  height: 40px;\n  font-weight: bold;\n  text-align: center;\n}\n.clearfix-day[data-v-0c013cc0] {\n  background-color: #5fb44a;\n  font-size: large;\n  height: 40px;\n  font-weight: bold;\n  text-align: center;\n}\n.clearfix-month[data-v-0c013cc0] {\n  background-color: #c694f9;\n  font-size: large;\n  height: 40px;\n  font-weight: bold;\n  text-align: center;\n}\n\n", ""]);

// exports
